import React from "react";
/** Services Import */
import Global from "../../Services/Common/Global";
import Commons from "../../Services/Common/Common";
import Dialog from "../../Services/Common/Dialog";
import IndexedDb from "../../Services/IndexedDb/IndexedDb";
/** Components Import */
import DB10010View from "../../Views/Dashboard/DB10010";
import Snackbar from "../../Components/Snackbar";

function DB10010(props) {
  const [snackbars, setSnackbars] = React.useState({
    toggle: false,
    type: "",
    message: "",
  });
  const [lanData, setLanData] = React.useState([]);
  const [tabToggle, setTabToggle] = React.useState(false);
  const [inputs, setInputs] = React.useState({
    comboValue: "",
    searchInput: "",
  });
  const [orderList, setOrderList] = React.useState([]);
  const [rowData, setRowData] = React.useState([]);
  const [paramsItemCd, setParamsItemCd] = React.useState("");
  const today = new Date();
  const monthAgo = new Date(today);
  const today1 = new Date();
  const dateAgo = new Date();
  const [startDate, setStartDate] = React.useState(
    new Date(monthAgo.setMonth(today.getMonth() - 3))
  );
  const [endDate, setEndDate] = React.useState(
    dateAgo.setDate(today1.getDate() + 1)
  );
  React.useEffect(() => {
    window.addEventListener("error", (e) => {
      if (e.message === "ResizeObserver loop limit exceeded") {
        const resizeObserverErrDiv = document.getElementById(
          "webpack-dev-server-client- overlay-div"
        );
        const resizeObserverErr = document.getElementById(
          "webpack-dev-server-client-overlay"
        );
        if (resizeObserverErr) {
          resizeObserverErr.setAttribute("style", "display: none");
        }
        if (resizeObserverErrDiv) {
          resizeObserverErrDiv.setAttribute("style", "display: none");
        }
      }
    });
    Init();
  }, []);

  const Init = async () => {
    Dialog.ProgressBar(true);
    let getLanData = [];
    let getRowData = [];
    let getRowData1 = [];

    try {
      await IndexedDb.GetAllDb("LanguageList").then((result) => {
        if (result.length > 0) {
          getLanData = result.filter((f) => f.lanType !== "MENU");
        }
      });

      await Commons.Axios(
        "get",
        Global.serverUrls.useUrl +
          Global.urls.logic.DataBase.DB10010.GetWorkOrder,
        {
          paramsItemCd:
            paramsItemCd == "" ||
            paramsItemCd == null ||
            paramsItemCd == undefined
              ? "string"
              : paramsItemCd,
          startDate: new Date(startDate),
          endDate: new Date(endDate),
        }
      ).then((result) => {
        let data = result.data;
        if (data === "데이터가 없습니다.") {
          setOrderList([]);
          setInputs({
            ...inputs,
            searchInput: "",
          });
        } else if (data.type === "Error") {
          throw new Error(data.message);
        } else {
          for (let i = 0; i < data.length; i++) {
            getRowData.push({
              name: data[i].itemNm,
              status: data[i].stusCd,
            });
          }
          for (let i = 0; i < data.length; i++) {
            getRowData1.push({
              plantCd: data[i].plantCd,
              soNo: data[i].soNo,
              soDt: data[i].soDt
                ? Commons.DateFormating(data[i].soDt.toString(), 2)
                : "",
              custCd: data[i].custCd,
              custNm: data[i].custNm,
              itemCd: data[i].itemCd,
              itemNm: data[i].itemNm,
              itemQty: data[i].itemQty,
              workQty: data[i].workQty ? data[i].workQty : 0,
              delivAmt: data[i].delivAmt,
              delivDt: data[i].delivDt,
              stusNm: data[i].stusNm,
              lossQty:
                data[i].itemQty - (data[i].workQty ? data[i].workQty : 0),
            });
          }
          setOrderList(getRowData);
          setRowData(Commons.InsertNumber(getRowData1));
        }
      });
    } catch (e) {
      setSnackbars({
        toggle: true,
        type: "error",
        message: e.message,
      });
    } finally {
      Dialog.ProgressBar(false);
    }
  };
  return (
    <>
      <DB10010View
        rowData={rowData}
        Init={Init}
        setRowData={setRowData}
        startDate={startDate}
        setStartDate={setStartDate}
        endDate={endDate}
        setEndDate={setEndDate}
        paramsItemCd={paramsItemCd}
        setParamsItemCd={setParamsItemCd}
      />
      {snackbars.toggle && (
        <Snackbar snackbars={snackbars} setSnackbars={setSnackbars} />
      )}
    </>
  );
}

export default DB10010;
